import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["card"];
  static values = { url: String };

  show() {
    // Catch cases of other hover cards
    document.querySelectorAll("[data-hovercard-target]").forEach( e => {e.classList.add("hide")})
    if (this.hasCardTarget) {
      this.cardTarget.classList.remove("hide");
    }
    else {
      fetch(this.urlValue)
        .then((r) => r.text())
        .then((html) => {
          const fragment = document
            .createRange()
            .createContextualFragment(html);

          this.element.appendChild(fragment);
        });

    }
  }

  hide() {
    if (this.hasCardTarget) {
      this.cardTarget.classList.add("hide");
    }
  }

  disconnect() {
    if (this.hasCardTarget) {
      this.cardTarget.remove();
    }
  }
}
